
export default {
    en: {
        accountemail: 'Account Email',
        emailprompt: 'Enter an email address for your account',
        signinPrompt: 'Already have an account? {0}.',
        continue: 'Continue',
        cancel: 'Cancel',
        password: 'Password',
        enterpassword: 'Enter password',
        confirmpassword: 'Confirm password',
        validationcode: 'Validation Code',
        validationcodeprompt: 'Enter the validation code sent to your email',
        signin_term: 'Your account has been created successfully. Please {0} to start.',
        signin_link: 'Sign in',
        requestanothercode_term: 'Please check your spam folder if a code doesn\'t arrive. {0}.',
        requestanothercode_link: 'Request another code',
        agree_terms: 'I agree to the <a href="{link}" target="_blank">Terms & Conditions</a>',
        validation_incorrect: 'The validation code was incorrect',
        validation_too_long: 'Verification code is too long. It must be five letters or numbers',
        validation_too_short: 'Verification code is too short. It must be five letters or numbers',
        validation_wait: 'Please wait at least 30 seconds for the validation email to arrive.',
        goal: 'Please describe what you are hoping to achieve',
        goaldetail: 'Give a brief explanation of what you are trying to do',
        reset: 'Reset',
        creatingaccount: "Creating account",
        createaccount: "Create account",
        completed: "completed",
        progress: {
            email: 'Email',
            password: 'Password',
            agreetotos: 'Agree to TOS',
            confirmdetails: 'Confirm details',
        },
        errors: {
            validation: "An error occurred validating the email",
            genauthcode: "There was a problem generating the authentication code.",
            validateemail: "There was a problem validating the email.",
            createaccount: "There was a problem creating the account.",
            createaccounterror: "There was a problem create the account. error code="
        }
    },
    de: {
        accountemail: 'Konto-E-Mail',
        emailprompt: 'Geben Sie eine E-Mail-Adresse für Ihr Konto ein',
        signinPrompt: 'Haben Sie bereits ein Konto? {0}.',
        continue: 'Weiter',
        cancel: 'Abbrechen',
        password: 'Passwort',
        enterpassword: 'Passwort eingeben',
        confirmpassword: 'Passwort bestätigen',
        validationcode: 'Validierungscode',
        validationcodeprompt: 'Geben Sie den an Ihre E-Mail gesendeten Validierungscode ein',
        signin_term: 'Ihr Konto wurde erfolgreich erstellt. Bitte {0}, um zu starten.',
        signin_link: 'Anmelden',
        requestanothercode_term: 'Bitte überprüfen Sie Ihren Spam-Ordner, falls kein Code eintrifft. {0}.',
        requestanothercode_link: 'Fordern Sie einen weiteren Code an',
        agree_terms: 'Ich stimme den <a href="{link}" target="_blank">Nutzungsbedingungen</a> zu',
        validation_incorrect: 'Der Validierungscode war falsch',
        validation_too_long: 'Der Validierungscode ist zu lang. Er muss aus fünf Buchstaben oder Zahlen bestehen',
        validation_too_short: 'Der Validierungscode ist zu kurz. Er muss aus fünf Buchstaben oder Zahlen bestehen',
        validation_wait: 'Bitte warten Sie mindestens 30 Sekunden, bis die Validierungs-E-Mail eintrifft.',
        goal: 'Bitte beschreiben Sie, was Sie erreichen möchten',
        goaldetail: 'Geben Sie eine kurze Erläuterung dessen ab, was Sie zu tun versuchen',
        reset: 'Zurücksetzen',
        creatingaccount: "Konto wird erstellt",
        createaccount: "Konto erstellen",
        completed: "erledigt",
        progress: {
            email: 'E-Mail',
            password: 'Passwort',
            agreetotos: 'AGB zustimmen',
            confirmdetails: 'Details bestätigen',
        },
        errors: {
            validation: 'Beim Überprüfen der E-Mail ist ein Fehler aufgetreten',
            genauthcode: 'Es gab ein Problem beim Generieren des Authentifizierungscodes.',
            validateemail: 'Es gab ein Problem bei der Validierung der E-Mail.',
            createaccount: 'Es gab ein Problem beim Erstellen des Kontos.',
            createaccounterror: "Es gab ein Problem beim Erstellen des Kontos. Fehlercode="
        }
    }
};
